module.exports = __webpack_public_path__ + "assets/img/portal.ecdeab4b.png";